import { render } from "./icebreakers.vue?vue&type=template&id=e182ac5e&lang=pug"
import script from "./icebreakers.vue?vue&type=script&lang=js"
export * from "./icebreakers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__